import { BiometriaApi } from "@/api/biometria/biometria.api";
const biometriaApi = new BiometriaApi();

const validaBiometria = (
  biometria: string
) => {
  return biometriaApi.validaBiometria(biometria);
};

export default {
  validaBiometria
};
